import { __rest } from '../../_virtual/_tslib.js';
import React__default from 'react';

const Image = (_a) => {
    var { path, alt, imageStyle } = _a, props = __rest(_a, ["path", "alt", "imageStyle"]);
    return React__default.createElement("img", Object.assign({ src: path, alt: alt, style: Object.assign({}, imageStyle) }, props, { width: props.width, height: props.height }));
};

export { Image as default };
//# sourceMappingURL=ProfileImage.js.map
